/**
 * External dependencies
 */
import React from "react";
import { Box, Heading } from "@towersystems/towersystems-design-system";
import { map, get, compact } from "lodash";
import { connect } from "react-redux";

/**
 * Internal dependencies
 */
import FormRadiosBar from "components/forms/form-radios-bar";
import { editReport } from "state/reports/actions";
import { getBuilderReportId } from "state/ui/report-builder/selectors";
import { getEditedReport } from "state/reports/selectors";

import AreaChartIcon from "modules/report-builder/chart-icons/area-chart";
import PieChartIcon from "modules/report-builder/chart-icons/pie-chart";
import BarChartIcon from "modules/report-builder/chart-icons/bar-chart";

import ColumnChartIcon from "modules/report-builder/chart-icons/column-chart";

import LineChartIcon from "modules/report-builder/chart-icons/line-chart";

import NumberChartIcon from "modules/report-builder/chart-icons/number-chart";
import TableChartIcon from "modules/report-builder/chart-icons/table-chart";

/**
 * Style dependencies
 */
import "./styles.scss";

export const chartConfig = {
  AREA: {
    value: "AREA",
    label: "AREA",
    thumbnail: {
      imageComponent: <AreaChartIcon />,
    },
  },
  BAR: {
    value: "BAR",
    label: "BAR",
    thumbnail: {
      imageComponent: <BarChartIcon />,
    },
  },
  TABLE: {
    value: "TABLE",
    label: "TABLE",
    thumbnail: {
      imageComponent: <TableChartIcon />,
    },
  },
  COLUMN: {
    value: "COLUMN",
    label: "COLUMN",
    thumbnail: {
      imageComponent: <ColumnChartIcon />,
    },
  },
  NUMBER: {
    value: "NUMBER",
    label: "NUMBER",
    thumbnail: {
      imageComponent: <NumberChartIcon />,
    },
  },
  LINE: {
    value: "LINE",
    label: "LINE",
    thumbnail: {
      imageComponent: <LineChartIcon />,
    },
  },
  PIE: {
    value: "PIE",
    label: "PIE",
    thumbnail: {
      imageComponent: <PieChartIcon />,
    },
  },
};

export const getTypes = (dataType) => {
  switch (dataType) {
    case "time_series":
      return ["AREA", "COLUMN", "LINE"];
    case "trends":
      return ["BAR", "TABLE", "COLUMN", "NUMBER"];
    default:
      return ["AREA", "BAR", "TABLE", "COLUMN", "NUMBER", "LINE", "PIE"];
  }
};

const SelectChartType = ({ reportId, chartType, dataType, ...props }) => {
  const handleOnChange = (e) => {
    props.editReport(reportId, { chartType: e.target.value });
  };

  return (
    <Box>
      <Box marginBottom="large">
        <Heading level="4">Choose chart type</Heading>
      </Box>
      <Box>
        <FormRadiosBar
          isThumbnail
          onChange={handleOnChange}
          checked={chartType}
          items={compact(
            map(getTypes(dataType), (type) => {
              return chartConfig[type];
            })
          )}
        />
      </Box>
    </Box>
  );
};

SelectChartType.defaultProps = {
  types: ["AREA", "BAR", "TABLE", "COLUMN", "NUMBER", "LINE", "PIE"],
};

export default connect(
  (state) => ({
    reportId: getBuilderReportId(state),
    dataType: get(
      getEditedReport(state, getBuilderReportId(state)),
      "config.dataType"
    ),
    chartType:
      get(getEditedReport(state, getBuilderReportId(state)), "chartType") ||
      get(getEditedReport(state, getBuilderReportId(state)), "chart_type"),
  }),
  {
    editReport,
  }
)(SelectChartType);
